<template>
  <div class="edit">
    <i class="close-btn icon icon--close-size16" @click="$emit('closePopup')" />
    <div class="edit__intro">
      <h3>{{ $t('ab.checkEdit') }}</h3>
      <span>{{ editData.length }}</span>
    </div>
    <div class="edit__contents">
      <div class="edit__contents__head">
        <div />
        <div class="a page">A Page</div>
        <div class="b page">B Page</div>
      </div>
      <div class="edit__contents__items">
        <div v-for="(item, index) in editData" :key="item.html">
          <div class="item">
            <span class="text">{{ index + 1 }}</span>
            <span class="text">{{ item.orgText }}</span>
            <span class="text update">{{ item.text }}</span>
          </div>
          <div class="item__select" @click="item.openHtml = !item.openHtml">
            <span>HTML</span>
            <i class="icon icon--arrow" :class="{open : item.openHtml}"></i>
          </div>
          <div class="item">
            <template v-if="item.openHtml">
              <div />
              <div class="code">{{ item.outerHTML && item.outerHTML.replace(item.text, item.orgText) }}</div>
              <div class="code">{{ item.outerHTML && item.outerHTML.replace(item.orgText, item.text) }}</div>
            </template>
          </div>
          <div class="division"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['editData']
}
</script>

<style lang="scss" scoped>
.edit {
  display: flex;
  flex-direction: column;
  row-gap: 22px;
  position: relative;

  width: 830px;
  height: 547px;
  padding: 35px 30px;
  border-radius: 14px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.35);
  background-color: #fff;

  .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  &__intro {
    display: flex;
    column-gap: 15px;
    align-items: center;

    h3 {
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #444;
    }

    span {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #1199af;
    }
  }

  &__contents {
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    box-sizing: border-box;
    height: 100%;
    padding-bottom: 35px;

    &__head {
      display: grid;
      grid-template-columns: 30px 365px 365px;
      column-gap: 15px;

      .page {
        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 5px;
        padding: 12px;

        font-size: 15px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: center;
        color: #fff;

        &.a {
          background-color: #9fce12;
        }
        &.b {
          background-color: #1199af;
        }
      }
    }

    &__items {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      overflow-x: hidden;
      overflow-y: scroll;

      height: 100%;

      .item {
        position: relative;
        display: grid;
        grid-template-columns: 30px 365px 365px;
        column-gap: 15px;

        box-sizing: border-box;

        &__index {
          text-align: center;
        }

        .text {
          box-sizing: border-box;
          padding-bottom: 30px;

          font-size: 14px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.36;
          letter-spacing: normal;
          text-align: center;
          color: #444;

          &.update {
            color: #1199af;
          }
        }

        &__select {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          left: 15px;

          padding-bottom: 10px;

          cursor: pointer;

          span {
            display: block;
            height: 14px;
            font-size: 12px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 14px;
            letter-spacing: normal;
            color: #888;
          }

          i {
            width: 14px;
            height: 14px;

            -ms-transform: rotate(90deg);
            -webkit-transform: rotate(90deg);
            transform: rotate(90deg);

            &.open {
              -ms-transform: rotate(-90deg);
              -webkit-transform: rotate(-90deg);
              transform: rotate(-90deg);
            }
          }
        }

        .code {
          padding: 10px 15px;
          border-radius: 5px;
          border: solid 1px #d7d7d7;
          background-color: #f4f4f4;
          margin-bottom: 20px;

          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.54;
          letter-spacing: normal;
          color: #444;
        }
      }

      .division {
        width: 745px;
        height: 1px;
        margin-left: 40px;

        background-color: #d8d8d8;
      }
    }
  }
}
</style>
